import { useState } from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { Box, Typography } from '@material-ui/core';

function DateControl(props) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(props.value ? new Date(props.value) : new Date());
  const {
    disabled,
    display,
    events = {},
    error,
    helperText,
    label,
    name,
    settings: {
      minPeriod,
      onlyDate,
    } = {},
    size,
    onChange,
    variant,
  } = props;
  const labelStyle = {
    textTransform: 'none',
    letterSpacing: '0.08em',
    fontSize: '11px',
    fontWeight: 700,
    color: '#6B7A90',
    ...display?.labelStyle,
  };
  if (disabled) {
    labelStyle.color = '#0000004e';
  }
  const inputStyle = {
    borderRadius: '12px',
    height: '44px',
    border: '#CED8E3',
    ...display?.inputStyle,
  };

  const format = {
    year: 'YYYY',
    month: 'YYYY MMMM',
  }[minPeriod] || 'yyyy-MM-DD';

  const openTo = {
    year: 'year',
    month: 'month',
  }[minPeriod] || 'date';

  const views = {
    year: ['year'],
    month: ['year', 'month'],
  }[minPeriod];

  const handleChange = function (date) {
    try {
      let value = new Date(date);

      if (minPeriod === 'year') {
        value = new Date(value.getFullYear(), 0, 1);
      } else if (minPeriod === 'month') {
        value = new Date(value.getFullYear(), value.getMonth(), 1);
      } else {
        value = new Date(value.getFullYear(), value.getMonth(), value.getDate());
      }

      if (onlyDate) {
        value = value.toISOString().split('T').shift();
      }

      const target = {
        name,
        value: value,
      };

      onChange({
        target,
      });

      if (events.onChange) {
        events.onChange(target);
      }

      setSelected(value);
    } catch (err) {
      setSelected(date);
    }
  };

  return (
    <Box
      sx={{
        mb: 2,
      }}
    >
      <Typography style={{
        ...labelStyle,
      }} variant="h6"
      gutterBottom>
        {label}
      </Typography>
      <KeyboardDatePicker
        autoOk={true}
        color="secondary"
        disabled={disabled}
        error={error}
        format={format}
        fullWidth={true}
        helperText={helperText}
        inputVariant={variant}
        InputProps={{
          style: {
            ...inputStyle,
          },
        }}
        InputLabelProps={{
          shrink: `${selected}` !== 'Invalid Date',
        }}
        name={name}
        open={open}
        openTo={openTo}
        size={size}
        value={selected}
        variant="inline"
        views={views}
        onChange={handleChange}
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}
        onClose={() => setOpen(false)}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />
    </Box>
  );
}

DateControl.defaultProps = {
  disabled: false,
  error: false,
  onChange: () => { },
  onBlur: () => { },
};

DateControl.propTypes = {
  disabled: PropTypes.bool,
  display: PropTypes.object,
  error: PropTypes.bool,
  events: PropTypes.object,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  settings: PropTypes.shape({
    minPeriod: PropTypes.oneOf(['year', 'month', 'day']),
    onlyDate: PropTypes.bool,
  }),
  size: PropTypes.oneOf([
    'small',
    'medium',
  ]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  variant: PropTypes.oneOf([
    'outlined',
    'standard',
  ]),
};

export default DateControl;
